import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "detailSettingsContent" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_3 = { class: "detailSettingsContent" }
const _hoisted_4 = {
  class: "smart_candi_calendar w100 ofh",
  style: {"height":"355px"}
}
const _hoisted_5 = {
  class: "calendarTimeSpan posRe",
  style: {"height":"350px"}
}
const _hoisted_6 = {
  key: 0,
  class: "posAb z1 pointer centered displayCal hasDays",
  style: {
                                        width: `32px`,
                                        lineHeight: `32px`,
                                        height: `32px`,
                                        top: `4px`,
                                        left: `80px`,
                                    }
}
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 1,
  class: "posAb z1 pointer centered displayCal hasDays",
  style: {
                                        width: `32px`,
                                        right: `80px`,
                                        top: `4px`,
                                        lineHeight: `32px`,
                                        height: `32px`,
                                    }
}
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "w100" }
const _hoisted_11 = {
  style: {"margin-top":"10px"},
  class: "w100"
}
const _hoisted_12 = { class: "wday_unit" }
const _hoisted_13 = { class: "days_unit w100" }
const _hoisted_14 = ["id"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["src"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Slide = _resolveComponent("Slide")!
  const _component_Carousel = _resolveComponent("Carousel")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("section", _hoisted_4, [
            _createElementVNode("div", {
              class: _normalizeClass(`calendar_area posSt ${_ctx.isSP ? `mc` : `fr`}`),
              style: {
                                width: `100%`,
                                height: `350px`,
                                borderRadius: `4px`,
                            }
            }, [
              _createElementVNode("div", _hoisted_5, [
                (_ctx.showPrevButton())
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("img", {
                        id: "pArrow",
                        class: "pArrow pointer mr2 mb2",
                        style: {"width":"16px"},
                        src: _ctx.$getAssetImageUrl(`/assets/icons/arrow_left.png`),
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickPrevMonth && _ctx.clickPrevMonth(...args)))
                      }, null, 8, _hoisted_7)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showNextButton())
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("img", {
                        id: "nArrow",
                        class: "nArrow pointer ml2 mb2",
                        style: {"width":"16px"},
                        src: _ctx.$getAssetImageUrl(`/assets/icons/arrow_right.png`),
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickNextMonth && _ctx.clickNextMonth(...args)))
                      }, null, 8, _hoisted_9)
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_Carousel, {
                  ref: "CalendarSlider",
                  "slides-to-show": 1,
                  style: _normalizeStyle({ '--slides-to-show': 1, '--slides-count': _ctx.visibleMonths.length })
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleMonths, (daysArray, monthindex) => {
                      return (_openBlock(), _createBlock(_component_Slide, {
                        key: `${monthindex}${_ctx.monthlyPossibleDates[monthindex]}${_ctx.pdm?.selectedPds?.length}${_ctx.visibleMonths.length}`,
                        class: _normalizeClass(`cal_${monthindex}`),
                        style: _normalizeStyle(`outline: none;${_ctx.calendarContentStyle()}`)
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("div", {
                              class: _normalizeClass(`month_${monthindex} fs18 mc dgrey centered fw600 arial mt10`),
                              style: {"width":"120px"}
                            }, _toDisplayString(_ctx.CalendarMonthTitle(monthindex)), 3),
                            _createElementVNode("table", _hoisted_11, [
                              _createElementVNode("tr", _hoisted_12, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weekArray, (weekday, weekindex) => {
                                  return (_openBlock(), _createElementBlock("th", {
                                    class: _normalizeClass(`fs10 centered ${
                                                            weekindex == 0 ? `sunHeader` : weekindex == 6 ? `satHeader` : ``
                                                        }`),
                                    key: weekday,
                                    style: _normalizeStyle({ ..._ctx.calendarCellWidth, height: `28px` })
                                  }, _toDisplayString(weekday), 7))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("table", _hoisted_13, [
                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList([0, 1, 2, 3, 4, 5], (i) => {
                                return _createElementVNode("tr", {
                                  key: `${i}${_ctx.monthlyPossibleDates[monthindex]}`,
                                  id: `start_week_${i}`
                                }, [
                                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList([0, 1, 2, 3, 4, 5, 6], (j) => {
                                    return _createElementVNode("td", {
                                      key: `${i}${j}`,
                                      class: _normalizeClass(`centered fs10 displayCal${monthindex}_${
                                                            daysArray[i * 7 + j]
                                                        } posRe`),
                                      style: _normalizeStyle({
                                                            ..._ctx.calendarCellWidth,
                                                            height: `43px`,
                                                        })
                                    }, [
                                      (daysArray[i * 7 + j] > 0)
                                        ? (_openBlock(), _createElementBlock("p", {
                                            key: 0,
                                            class: _normalizeClass(`displayCal mc ${
                                                                _ctx.monthlyPossibleDates[monthindex].includes(daysArray[i * 7 + j])
                                                                    ? `pointer hasDays `
                                                                    : ``
                                                            } ${
                                                                !_ctx.isPreview &&
                                                                _ctx.pdm.selectedPds.find(
                                                                    pd =>
                                                                        pd.date_format ==
                                                                        _ctx.dateFormat(monthindex, daysArray[i * 7 + j])
                                                                )
                                                                    ? `suggested`
                                                                    : ``
                                                            }`),
                                            style: _normalizeStyle(_ctx.displayCalSize),
                                            onClick: ($event: any) => (_ctx.clickDisplayCal(monthindex, daysArray[i * 7 + j]))
                                          }, _toDisplayString(daysArray[i * 7 + j]), 15, _hoisted_15))
                                        : _createCommentVNode("", true),
                                      (monthindex == 0 && daysArray[i * 7 + j] == _ctx.today)
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 1,
                                            src: _ctx.$getAssetImageUrl(`/assets/icons/sankaku_dblue.png`),
                                            class: "posAb",
                                            style: {"left":"42%","bottom":"4px"},
                                            width: "9",
                                            height: "9"
                                          }, null, 8, _hoisted_16))
                                        : _createCommentVNode("", true)
                                    ], 6)
                                  }), 64))
                                ], 8, _hoisted_14)
                              }), 64))
                            ])
                          ]),
                          _hoisted_17
                        ]),
                        _: 2
                      }, 1032, ["class", "style"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["style"])
              ]),
              _hoisted_18
            ], 2)
          ]),
          _hoisted_19
        ])
      ])
    ])
  ]))
}